// Extracts a readable message from an Axios error (NestJS returns
// `message` as a string or, for validation errors, an array).
export const getErrorMessage = (error, fallback) => {
  const message = error?.response?.data?.message;
  if (Array.isArray(message)) return message.join(", ");
  return message || fallback;
};
